import React, { useEffect, useState } from 'react'
import {
    View,
    Text,
    StyleSheet,
    TouchableOpacity,
    Modal,
    Pressable,
    Alert,
    PixelRatio,
    Dimensions,
    StatusBar,
    Platform,
} from 'react-native'
import { UserServices } from '../../../../database/user.database'
import { FlashList } from '@shopify/flash-list'
import { ScrollView, TextInput } from 'react-native-gesture-handler'
import { useAndroidNavBarHeight } from '@/components/customUtils/hooks/useAndroidNavBarHeight'
import { Feather } from '@expo/vector-icons'
import theme from '../../../../theme'
import * as Clipboard from 'expo-clipboard'
import { useToast } from '../../../redux/zustand/useToast'
import { Toast } from '../../../components/customUtils/Components/Toast'

const TableViewerScreen = () => {
    const [tables, setTables] = useState([]) // Para guardar la lista de tablas
    const [tableData, setTableData] = useState([]) // Para guardar los datos de la tabla seleccionada
    const [selectedTable, setSelectedTable] = useState(null) // Tabla actualmente seleccionada
    const [selectedColumns, setSelectedColumns] = useState([])
    const [allColumns, setAllColumns] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize] = useState(10)
    const [totalReg, setTotalReg] = useState(0)
    const [selectedItem, setSelectedItem] = useState(null)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [searchTerm, setSearchTerm] = useState(null)
    const [sqlQuery, setSqlQuery] = useState('') // Para la query SQL pura
    const setToast = useToast((toast) => toast.setToast)

    const copyRegister = async (text) => {
        if (!text || text === '') return
        const textToCopy = JSON.stringify(text)
        const copied = await Clipboard.setStringAsync(textToCopy)
        if (copied) {
            setToast('El texto se ha copiado')
            // Alert.alert('El texto se ha copiado')
        }
    }

    const printRegister = async (text) => {
        if (!text || text === '') return
        console.log('📋 Registro completo:', text)
        setToast('Registro completo impreso en consola')
    }

    const executeRawSQLQuery = async () => {
        if (!sqlQuery || sqlQuery.trim() === '') {
            Alert.alert('Error', 'Por favor ingresa una query SQL')
            return
        }

        try {
            console.log('🔍 ==========================================')
            console.log('🔍 [SQL QUERY]:', sqlQuery)
            console.log('🔍 ==========================================')

            const result = await UserServices.executeRawQuery(sqlQuery)

            console.log('✅ ==========================================')
            console.log('✅ [SQL RESULT] Registros encontrados:', result.length)
            console.log('✅ [SQL DATA]:', result)
            console.log('✅ ==========================================')

            setToast(`Query ejecutada: ${result.length} registros encontrados`)
        } catch (error) {
            console.error('❌ ==========================================')
            console.error('❌ [SQL ERROR]:', error)
            console.error('❌ ==========================================')
            Alert.alert('Error', error.toString())
        }
    }

    useEffect(() => {
        const fetchTables = async () => {
            let tables = await UserServices.getTableNames()
            // Ordenar las tablas en orden alfabético
            tables.sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }))

            setTables(tables)
        }

        fetchTables()
    }, [])

    // Obtener los datos de una tabla seleccionada
    const fetchTableData = async (
        tableName,
        page = 1,
        pageSize = 10,
        clear = false,
    ) => {
        let get_table = await UserServices.getTableData(
            tableName,
            page,
            pageSize,
            !clear ? searchTerm : null,
        )
        //console.log("🚀 ~ fetchTableData ~ get_table:", get_table)
        if (page == 1) {
            let count_reg = await UserServices.getCountTableData(
                tableName,
                !clear ? searchTerm : null,
            )
            setTotalReg(count_reg)
        }
        setTableData(get_table)
        setSelectedTable(tableName)

        if (get_table.length > 0) {
            const columns = Object.keys(get_table[0])
            if (page == 1) {
                setAllColumns(columns)
                setSelectedColumns(columns) // Inicializa con todas las columnas
            }
        }
    }
    const clearSearch = async (tableName, page = 1, pageSize = 10) => {
        try {
            setSearchTerm(null)
        } catch (error) {
            console.error('~ clearSearch ~ error:', error)
        } finally {
            fetchTableData(tableName, page, pageSize, true)
        }
    }
    const goToNextPage = () => {
        setCurrentPage((prevPage) => prevPage + 1)
        fetchTableData(selectedTable, currentPage + 1, pageSize)
    }

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1)
            fetchTableData(selectedTable, currentPage - 1, pageSize)
        }
    }

    const renderColumnSelector = () => {
        return (
            <View style={styles.columnSelectorContainer}>
                {allColumns.map((column, index) => (
                    <TouchableOpacity
                        key={index}
                        onPress={() => toggleColumnSelection(column)}
                        style={{
                            backgroundColor: selectedColumns.includes(column)
                                ? theme.colors.colorSecondary
                                : '#f0f0f0',
                            paddingVertical: 5,
                            paddingHorizontal: 8,
                            margin: 5,
                            borderRadius: 10,
                        }}
                    >
                        <Text
                            style={{
                                color: selectedColumns.includes(column)
                                    ? '#fff'
                                    : '#000',
                                fontSize: 10,
                                fontWeight: '700',
                            }}
                        >
                            {column}
                        </Text>
                    </TouchableOpacity>
                ))}
            </View>
        )
    }

    const toggleColumnSelection = (column) => {
        setSelectedColumns((prev) => {
            const isSelected = prev.includes(column)

            // determinamos nuevo estado seleccionado (sin orden)
            const newSelected = isSelected
                ? prev.filter((c) => c !== column)
                : [...prev, column]

            // reordenamos según allColumns
            return allColumns.filter((c) => newSelected.includes(c))
        })
    }

    const renderTableDataItem0 = ({ item }) => {
        const truncateValue = (value) => {
            if (typeof value === 'string' && value.length > 24) {
                return value.substring(0, 90) + '...'
            }
            return value
        }

        return (
            <View style={styles.tableRow}>
                <ScrollView horizontal={true} style={styles.scrollRow}>
                    {selectedColumns.map((key, index) => (
                        <View key={index} style={styles.tableCell}>
                            <Text style={styles.cellLabel}>{key}:</Text>
                            <Text style={styles.cellValue}>
                                {typeof item[key] === 'object'
                                    ? JSON.stringify(item[key])
                                    : truncateValue(item[key])}
                            </Text>
                        </View>
                    ))}
                </ScrollView>
            </View>
        )
    }
    const renderTableDataItem = ({ item }) => {
        const truncateValue = (value) => {
            if (typeof value === 'string' && value.length > 24) {
                return value.substring(0, 90) + '...'
            }
            return value
        }

        return (
            <TouchableOpacity
                onPress={() => {
                    setSelectedItem(item)
                    setIsModalVisible(true)
                }}
                style={styles.tableRow}
            >
                <ScrollView
                    horizontal={true}
                    showsHorizontalScrollIndicator={true}
                    style={styles.scrollRow}
                    contentContainerStyle={styles.scrollContent}
                >
                    {selectedColumns.map((key, index) => (
                        <View key={index} style={styles.tableCell}>
                            <Text style={styles.cellLabel}>{key}:</Text>
                            <Text style={styles.cellValue}>
                                {typeof item[key] === 'object'
                                    ? JSON.stringify(item[key])
                                    : truncateValue(item[key])}
                            </Text>
                        </View>
                    ))}
                </ScrollView>

                {/* <ScrollView horizontal={true} style={styles.scrollRow}>
                    {selectedColumns.map((key, index) => (
                        <View key={index} style={styles.tableCell}>
                            <Text style={styles.cellLabel}>{key}:</Text>
                            <Text style={styles.cellValue}>
                                {typeof item[key] === 'object' ? JSON.stringify(item[key]) : truncateValue(item[key])}
                            </Text>
                        </View>
                    ))}
                </ScrollView> */}
            </TouchableOpacity>
        )
    }
    const renderModal = () => {
        if (!selectedItem) return null

        return (
            <Modal
                visible={isModalVisible}
                transparent={true}
                animationType='slide'
                onRequestClose={() => setIsModalVisible(false)}
            >
                <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>
                        <View
                            style={{
                                flexDirection: 'row',
                                width: '100%',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Text
                                style={[styles.modalTitle, { paddingVertical: 5 }]}
                            >
                                Detalles
                            </Text>
                            <Pressable onPress={() => copyRegister(selectedItem)}>
                                <Text
                                    style={{
                                        color: 'white',
                                        backgroundColor: theme.colors.colorPrimary,
                                        paddingVertical: 5,
                                        paddingHorizontal: 8,
                                        borderRadius: 5,
                                    }}
                                >
                                    Copiar
                                </Text>
                            </Pressable>

                            <Pressable onPress={() => printRegister(selectedItem)}>
                                <Text
                                    style={{
                                        color: 'white',
                                        backgroundColor: theme.colors.colorPrimary,
                                        paddingVertical: 5,
                                        paddingHorizontal: 8,
                                        borderRadius: 5,
                                    }}
                                >
                                    Print
                                </Text>
                            </Pressable>
                        </View>
                        <ScrollView>
                            {Object.keys(selectedItem).map((key, index) => (
                                <View key={index} style={styles.modalRow}>
                                    <Text style={styles.modalKey}>{key}:</Text>
                                    <Text
                                        style={styles.modalValue}
                                        selectable={true}
                                    >
                                        {typeof selectedItem[key] === 'object'
                                            ? JSON.stringify(selectedItem[key])
                                            : selectedItem[key]}
                                    </Text>
                                </View>
                            ))}
                        </ScrollView>
                        <TouchableOpacity
                            style={styles.closeButton}
                            onPress={() => setIsModalVisible(false)}
                        >
                            <Text style={styles.closeButtonText}>Cerrar</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                <Toast />
            </Modal>
        )
    }

    const totalPages = Math.ceil(totalReg / pageSize)

    const renderTableItem = ({ item }) => (
        <View style={styles.tableItem}>
            <TouchableOpacity
                onPress={() => fetchTableData(item)}
                style={styles.button}
                activeOpacity={0.6}
            >
                <Text style={styles.buttonText}>{item} </Text>
            </TouchableOpacity>
        </View>
    )
    const navBarHeight = useAndroidNavBarHeight()
    const [showSelector, toogleSelector] = useState(true)

    const setDemoInfo = () => {
        const windowHeight = Dimensions.get('window').height
        const screenHeight = Dimensions.get('screen').height

        // Diferencia = área ocupada por nav bar (y a veces status bar)
        const diff = screenHeight - windowHeight - (StatusBar.currentHeight || 0)
        let info = {
            'Botones de navegación:': navBarHeight,
            'PixelRatio: ': PixelRatio.get(),
            'FontScale: ': PixelRatio.getFontScale(),
            'Screen Info': JSON.stringify({
                WindowHeight: windowHeight,
                ScreenHeight: screenHeight,
                statusbarHeight: StatusBar.currentHeight || 0,
                Diff: diff,
            }),
        }
        setSelectedItem(info)
        setIsModalVisible(true)
        return
    }

    return (
        <View style={styles.container}>
            <View style={{ flex: 1, padding: 10 }}>
                <Pressable
                    onPress={() => {
                        setDemoInfo()
                    }}
                >
                    <Text style={styles.title}>DB</Text>
                </Pressable>

                {/* SQL Query Input */}
                <View style={styles.sqlQueryContainer}>
                    <Text style={styles.sqlQueryLabel}>
                        Ejecutar SQL Query (SELECT):
                    </Text>
                    <TextInput
                        placeholder='Ej: SELECT * FROM form_question_answers LIMIT 1'
                        value={sqlQuery}
                        onChangeText={setSqlQuery}
                        style={styles.sqlQueryInput}
                        autoCapitalize='none'
                        multiline
                        numberOfLines={3}
                    />
                    <TouchableOpacity
                        onPress={executeRawSQLQuery}
                        style={styles.sqlQueryButton}
                    >
                        <Text style={styles.sqlQueryButtonText}>
                            ▶ Ejecutar y mostrar en consola
                        </Text>
                    </TouchableOpacity>
                </View>

                {/* <Text>Botones de navegación: {navBarHeight}</Text> */}
                <FlashList
                    data={tables}
                    renderItem={renderTableItem}
                    keyExtractor={(item) => item}
                    estimatedItemSize={30}
                    numColumns={1}
                />
            </View>
            {selectedTable && (
                <ScrollView
                    style={[
                        {
                            position: 'absolute',
                            top: 0,
                            start: 0,
                            end: 0,
                            bottom: 0,
                            backgroundColor: 'white',
                            width: '100%',
                            height: '100%',
                            padding: 10,
                        },
                    ]}
                >
                    <Text style={[styles.subtitle]}>
                        Tabla: {selectedTable.toUpperCase()},
                    </Text>
                    <Text style={[styles.subtitle, { flex: 1, fontWeight: '400' }]}>
                        Count: {totalReg}, Size: {pageSize}, Maxpage: {totalPages}
                    </Text>
                    <View
                        style={{
                            flexDirection: 'row',
                            width: '100%',
                            flexShrink: 0,
                            gap: 10, // o podés usar marginRight en el primero
                        }}
                    >
                        <Pressable
                            onPress={() => setSelectedTable(null)}
                            style={{
                                flex: 1,
                                backgroundColor: 'black',
                                borderRadius: 12,
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: 10,
                            }}
                        >
                            <Feather name='arrow-left' size={20} color={'white'} />
                        </Pressable>

                        <Pressable
                            onPress={() => toogleSelector(!showSelector)}
                            style={{
                                flex: 1,
                                backgroundColor: theme.colors.colorPrimary,
                                borderRadius: 12,
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: 10,
                            }}
                        >
                            <Feather
                                name={'arrow-' + (showSelector ? 'up' : 'down')}
                                size={20}
                                color={'white'}
                            />
                        </Pressable>
                    </View>

                    {showSelector && renderColumnSelector()}
                    <View style={styles.searchContainer}>
                        <TextInput
                            placeholder='key, operador, valor'
                            value={searchTerm}
                            onChangeText={setSearchTerm}
                            style={styles.searchInput}
                            autoCapitalize='none'
                        />
                        <TouchableOpacity
                            onPress={() =>
                                fetchTableData(selectedTable, 1, pageSize)
                            }
                            style={styles.searchButton}
                        >
                            <Text style={styles.searchButtonText}>Buscar</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                            onPress={() => clearSearch(selectedTable, 1, pageSize)}
                            style={styles.searchButton}
                        >
                            <Text style={styles.searchButtonText}>Limpiar</Text>
                        </TouchableOpacity>
                    </View>
                    {totalPages > 0 && (
                        <View style={styles.paginationContainer}>
                            <TouchableOpacity
                                onPress={() => goToPreviousPage()}
                                style={[
                                    styles.paginationButton,
                                    currentPage === 1 && styles.disabledButton, // Deshabilita si estás en la primera página
                                ]}
                                disabled={currentPage === 1}
                            >
                                <Feather
                                    name={'arrow-left'}
                                    size={16}
                                    color={'white'}
                                />
                            </TouchableOpacity>

                            <Text style={styles.paginationInfo}>
                                Página {currentPage}
                            </Text>

                            <TouchableOpacity
                                onPress={() => goToNextPage()}
                                style={[
                                    styles.paginationButton,
                                    currentPage === totalPages &&
                                        styles.disabledButton, // Deshabilita si estás en la última página
                                ]}
                                disabled={currentPage === totalPages} // Desactivar cuando se esté en la última página
                            >
                                <Feather
                                    name={'arrow-right'}
                                    size={16}
                                    color={'white'}
                                />
                            </TouchableOpacity>
                        </View>
                    )}
                    <ScrollView
                        horizontal={true}
                        contentContainerStyle={styles.scrollViewContent}
                    >
                        <View style={styles.tableDataWrapper}>
                            {tableData.map((item, index) => (
                                <View key={index} style={styles.tableRow}>
                                    {renderTableDataItem({ item })}
                                </View>
                            ))}
                        </View>
                    </ScrollView>
                </ScrollView>
            )}
            {renderModal()}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    tableItem: {
        marginVertical: 6,
        // flexDirection: "row",
        flex: 1,
        flexWrap: 'wrap',
    },
    tableDataContainer: {
        marginTop: 10,
        padding: 10,
        borderTopWidth: 1,
        borderColor: '#ccc',
        flex: 1,
    },
    subtitle: {
        fontSize: 16,
        fontWeight: '600',
        marginBottom: 10,
    },
    tableRow: {
        marginBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#ddd',
        paddingVertical: 2,
    },
    scrollContent: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    scrollRow: {
        flexDirection: 'row',
        paddingHorizontal: 10,
        paddingVertical: 5,
    },
    tableCell: {
        paddingHorizontal: 10,
        marginBottom: 5,
        flexDirection: 'column',
    },
    cellLabel: {
        fontWeight: 'bold',
        fontSize: 10,
    },
    cellValue: {
        fontSize: 12,
        maxWidth: 180,
        overflow: 'hidden',
        // textOverflow: 'ellipsis',
        //whiteSpace: 'nowrap', // Esto asegura que el texto no se ajuste a múltiples líneas
    },
    button: {
        width: '100%',
        backgroundColor: '#6c757d',
        paddingVertical: 5,
        paddingHorizontal: 20,
        borderRadius: 5,
        alignItems: 'flex-start',
        //marginVertical: 1,
    },
    buttonText: {
        color: '#fff',
        fontSize: 12,
        fontWeight: '600',
        textTransform: 'uppercase',
    },
    backButton: {
        marginVertical: 10,
        paddingVertical: 10,
        backgroundColor: '#6c757d',
        borderRadius: 5,
        alignItems: 'center',
    },
    backButtonText: {
        color: '#fff',
        fontSize: 16,
        fontWeight: '600',
    },
    columnSelectorContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        marginTop: 10,
    },
    scrollViewContent: {
        paddingBottom: 20,
    },
    tableDataWrapper: {
        flex: 1,
    },
    paginationContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 10,
    },
    paginationButton: {
        paddingVertical: 5,
        paddingHorizontal: 12,
        backgroundColor: '#007BFF',
        borderRadius: 5,
    },
    disabledButton: {
        backgroundColor: '#CCC',
    },
    paginationText: {
        color: '#FFF',
        fontSize: 16,
    },
    paginationInfo: {
        fontSize: 16,
        fontWeight: 'bold',
    },
    modalContainer: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContent: {
        width: '95%',
        height: '90%',
        backgroundColor: '#fff',
        borderRadius: 10,
        padding: 20,
        shadowColor: '#000',
        shadowOpacity: 0.25,
        shadowRadius: 12,
        elevation: 5,
    },
    modalTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 10,
    },
    modalRow: {
        marginVertical: 5,
    },
    modalKey: {
        fontWeight: 'bold',
    },
    modalValue: {
        fontSize: 14,
    },
    closeButton: {
        marginTop: 20,
        backgroundColor: '#6c757d',
        padding: 10,
        borderRadius: 5,
        alignItems: 'center',
    },
    closeButtonText: {
        color: '#fff',
        fontSize: 16,
    },
    searchContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: 10,
    },
    searchInput: {
        flex: 1,
        padding: 10,
        borderWidth: 1,
        borderColor: '#ccc',
        borderRadius: 5,
    },
    searchButton: {
        marginLeft: 10,
        paddingVertical: 10,
        paddingHorizontal: 15,
        backgroundColor: '#007bff',
        borderRadius: 5,
    },
    searchButtonText: {
        color: 'white',
        fontWeight: 'bold',
    },
    sqlQueryContainer: {
        marginVertical: 15,
        padding: 12,
        backgroundColor: '#f8f9fa',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#dee2e6',
    },
    sqlQueryLabel: {
        fontSize: 14,
        fontWeight: '600',
        marginBottom: 8,
        color: '#495057',
    },
    sqlQueryInput: {
        padding: 10,
        backgroundColor: '#fff',
        borderWidth: 1,
        borderColor: '#ced4da',
        borderRadius: 5,
        fontSize: 13,
        fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace',
        minHeight: 70,
        textAlignVertical: 'top',
    },
    sqlQueryButton: {
        marginTop: 10,
        paddingVertical: 12,
        paddingHorizontal: 15,
        backgroundColor: '#28a745',
        borderRadius: 5,
        alignItems: 'center',
    },
    sqlQueryButtonText: {
        color: 'white',
        fontWeight: 'bold',
        fontSize: 14,
    },
})

export default TableViewerScreen
